import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { menuActions } from "./actions";
import { MenuState } from "./types";

const initialState: MenuState = {
  menusInCart: null,
  menusToReorder: null,
};

export function MenuReducer(state = initialState, action: Action): MenuState {
  if (isType(action, menuActions.getMenusFromCart.done)) {
    return {
      ...state,
      menusInCart: action.payload.result,
    };
  }

  if (isType(action, menuActions.setMenuInCart.done)) {
    return {
      ...state,
      menusInCart: action.payload.result,
    };
  }

  if (isType(action, menuActions.addMenuToCart.done)) {
    return {
      ...state,
      menusInCart: action.payload.result,
    };
  }

  if (isType(action, menuActions.addCouponMenusToCart.done)) {
    return {
      ...state,
      menusInCart: action.payload.result,
    };
  }

  if (isType(action, menuActions.removeMenuFromCart.done)) {
    return {
      ...state,
      menusInCart: action.payload.result,
    };
  }

  if (isType(action, menuActions.removeMenuFromCartByCouponUuids.done)) {
    return {
      ...state,
      menusInCart: action.payload.result,
    };
  }

  if (isType(action, menuActions.setMenusToReorder)) {
    return {
      ...state,
      menusToReorder: action.payload,
    };
  }

  if (isType(action, menuActions.cancelReorder)) {
    return {
      ...state,
      menusToReorder: null,
    };
  }

  if (isType(action, menuActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
